import React from 'react'

const AppWrap = (Component, classNames) =>
  function HOC() {
    return (
      <div className={`app__container ${classNames}`}>
        <div className="app__wrapper app__flex">
          <Component />

          <div className="copyright">
            <p className="p-text">@2023 Ethan Pham</p>
            <p className="p-text">All rights reserved</p>
          </div>
        </div>
      </div>
    )
  }

export default AppWrap
